import { jsx } from "react/jsx-runtime";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { validateTidalLicense } from "../../base/index.js";
function RequestQuote(props) {
  return /* @__PURE__ */ jsx(
    RequestQuoteIcon,
    {
      "data-testid": "RequestQuote",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "RequestQuote",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
RequestQuote.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "RequestQuote"
};
validateTidalLicense();
export {
  RequestQuote
};
//# sourceMappingURL=RequestQuote.js.map
